import Intercom from '@intercom/messenger-js-sdk';

function TestPage() {


Intercom({
    app_id: 'sr0dlb76',
    custom_attributes: {
        user_type: 'brokers', // 👈 key part
    },
    utm_term: 'broker'

})
return (
    <div style={{height: '100vh', background: 'beige'}}/>
)
}

export default TestPage